<script>
  import Breadcrumbs from '@components/Breadcrumbs'
  import RenderNodes from '@components/Templates/Serializer/RenderNodes'
  import Related from '@components/Related'
  import Modal from '@components/Modal'
  import Gallery from '@components/Gallery'
  import ShareBlock from '@components/ShareBlock'
  import ListimBtn from '@components/ListimBtn'
  import { onMount } from 'svelte'
  export let title,
    path,
    cover,
    center_x = 50,
    center_y = 50,
    breadcrumbs = [],
    nodes = [],
    listim_id,
    pubdate,
    related = [];
  let isTerminal;

  onMount(() => {
    isTerminal = localStorage.isTerminal;
  });
</script>

  {#if cover}
    <div
      class="cover-container d-flex align-items-center justify-content-center position-relative"
      style="background-image: url({cover}); background-position-y: {center_y}%; background-position-x: { center_x }%">
      <span class="text">{title}</span>
      <div class="shadow"></div>
    </div>
  {/if}
  <div class="breadcrumbs-container position-relative d-flex align-items-xl-center flex-column flex-xl-row">
    <Breadcrumbs {breadcrumbs} />
    <div class="btn-container mt-3 mt-xl-0">
      {#if listim_id && !isTerminal}
        <ListimBtn id={listim_id} className="pay-btn mb-5 mb-sm-0">Купить билет</ListimBtn>
      {/if}
    </div>
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-8 position-static" id="content-container">
        {#if related.length}
          <div class="position-relative desktop-related">
            <div class="related-container">
              <div class="related-container-title font-bold">Читайте также</div>
              {#each related as item}
                <Related {...item} />
              {/each}
            </div>
          </div>
        {/if}
        <RenderNodes {nodes} />
        {#if pubdate}
          <div class="publish-info mb-4 mb-xl-1"><span>Дата публикации: {pubdate}</span></div>
        {/if}
        <div
          class='end-page-container'
          class:d-sm-flex={listim_id}
          class:justify-content-sm-between={listim_id}
          class:align-items-sm-center={listim_id}
        >
          {#if listim_id && !isTerminal}
            <ListimBtn id={listim_id} className="pay-btn mb-5 mb-sm-0">Купить билет</ListimBtn>
          {/if}
          <div class="share-blocks">
            {#if listim_id && !isTerminal}
              <div class='source-title mr-2'>Поделиться:</div>
              <ShareBlock />
            {/if}
          </div>
        </div>
        {#if related.length}
          <div class="mobile-related">
            <div class="related-container">
              <div class="related-container-title font-bold text-left">Читайте также</div>
              <div class="row">
                {#each related as item}
                  <div class="col-12 col-md-3 col-sm-4">
                    <Related {...item} />
                  </div>
                {/each}
              </div>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
<style>
  #content-container {
    text-align: left;
    @media (min-width: 1200px) {
      text-align: justify;
    }
  }
  .source-title {
    font-size: 1rem;
  }
  .breadcrumbs-container {
    padding-top: 30px;
    padding-bottom: 30px;
    @media(min-width: 1200px) {
      padding-bottom: 80px;
      max-width: calc(100% - 300px);
    }
    @media (min-width: 1500px) {
      max-width: 1000px;
    }
    margin: auto;
  }
  .publish-info {
    font-style: italic;
    color: #9b9b9b;
  }
  .btn-container {
    width: 100%;
    text-align: right;
    @media(min-width: 1200px) {
      position: absolute;
      left: calc(100% + 30px);
      max-width: 200px;
    }
  }
  .end-page-container {
    margin-bottom: 50px;
  }
  :global(.pay-btn) {
    @media(min-width: 576px) {
      max-width: 200px;
    }
  }
  .cover-container {
    height: 420px;
    text-align: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin: 0 -100px;
    padding: 0 100px;
    @media(max-width: 767px) {
      margin: 0 -15px;
      padding: 0 15px;
      max-height: 200px;
    }
  .shadow {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.46);
    z-index: 1;
  }
    .text {
      position: relative;
      z-index: 2;
      color: white;
      line-height: 3.5rem;
      /* max-height: 7rem; */
      /* overflow: hidden; */
      font-size: 2.25rem;
      @media (max-width: 767px) {
        font-size: 1rem;
        line-height: 1.5rem;
      }
      text-transform: uppercase;
    }
  }

  .mobile-related {
    display: none;
    margin-bottom: 50px;
    @media (max-width: 1699px) {
      display: block
    }
    .related-container {
      max-width: 100%;
      padding: 0;
      border: none;
    }
  }

  .desktop-related {
    display: none;
    @media (min-width: 1700px) {
      display: block
    }
    .related-container {
      position: absolute;
      top: 0;
      left: -350px;
    }
  }

  .related-container {
    padding: 10px;
    background: white;
    z-index: 1;
    border: 1px solid #8080804a;
    max-width: 200px;
    .related-container-title {
      text-align: center;
      padding-bottom: 5px;
      border-bottom: 1px solid black;
      font-size: 1.25rem;
      margin-bottom: 20px;
    }
  }

  .share-blocks {
	  display: flex;
    @media(min-width: 767px) {
      justify-content: flex-end;
    }
    @media(max-width: 767px) {
      flex-wrap: wrap;
    }
  }
</style>
